const steps = [
  { number: "1", title: "Phone Diagnosis", desc: "Describe the issue. We identify the likely cause over the phone." },
  { number: "2", title: "Flat-Rate Quote", desc: "Honest pricing before we arrive. No surprises." },
  { number: "3", title: "Same-Day Repair", desc: "Tech arrives with common parts and fixes the issue." },
  { number: "4", title: "30-Day Guarantee", desc: "Workmanship guaranteed. Call back if anything feels off." },
];

export default function ProcessTimeline() {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-[#064e3b] text-3xl md:text-4xl font-black text-center mb-14">
          Our 4-Step Repair Process
        </h2>
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 relative">
          {steps.map((step, i) => (
            <div key={i} className="flex-1 flex flex-col items-center text-center relative">
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-6 left-[60%] w-[80%] h-[2px] bg-[#ea580c]/30" />
              )}
              <div className="w-12 h-12 flex items-center justify-center bg-[#ea580c] text-white text-lg font-black mb-4 relative z-10">
                {step.number}
              </div>
              <h3 className="text-[#1a1a1a] text-lg font-bold mb-2">{step.title}</h3>
              <p className="text-[#555555] text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}